import React, { useEffect } from "react";
import { Checkbox, Grid } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";
import EmptyData from "../../../StyledComponents/Table/EmptyData";
import TableSkeleton from "../../../StyledComponents/TableSkeleton";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});

function VendorFinancingTable({
  vendorList,
  setVendorList,
  loading,
  sentToTreasury,
  treasuryState,
  setTreasuryState,
  sumNetAmount,
  setSumNetAmount,
  validate,
  page,
  RowsPerPage,
  waitMessage,
  UnBatch,
}) {
  const incoiceChecked = (e, id) => {
    if (e.target.checked) {
      setTreasuryState({
        ...treasuryState,
        invoices: [...treasuryState.invoices, id],
      });
    } else {
      let data = treasuryState.invoices.filter((i) => i != id);

      setTreasuryState({ ...treasuryState, invoices: data });
    }
  };
  const checkAll = (e, invoices) => {
    if (e.target.checked) {
      let data = invoices?.map((item) => {
        return item.Invoice_Id;
      });

      setTreasuryState({
        ...treasuryState,
        invoices: [...data],
        LC_Id : invoices[0]?.LC_Id
      });
    } else {
      setSumNetAmount(0);
      setTreasuryState({
        ...treasuryState,
        invoices: [],
      });
    }
  };
  const isChecked = (item) => {
    const { invoices } = treasuryState;
    if (invoices.length === 0) return false;
    const itemInvoiceIds = item.invoices.map((y) => y.Invoice_Id);

    return itemInvoiceIds.every((id) => invoices.includes(id));
  };

  useEffect(() => {
    let sumNetAmount = 0;

    if (sentToTreasury === "sent to Treasury") {
      vendorList?.forEach((vendor) => {
        vendor?.invoices?.forEach((invoice) => {
          if (treasuryState?.invoices?.includes(invoice?.Invoice_Id)) {
            sumNetAmount += Number(invoice?.NT_AMNT || 0);
          }
        });
      });
    } else {
      vendorList?.forEach((vendor) => {
        if (treasuryState?.invoices?.includes(vendor?.Invoice_Id)) {
          sumNetAmount += Number(vendor?.NT_AMNT || 0);
        }
      });
    }

    setSumNetAmount(sumNetAmount);
  }, [treasuryState.invoices, sentToTreasury, vendorList]);

  const classes = useStyles();

  const show = (item) => {
    setVendorList((prevList) => {
      const newList = [...prevList]; // Copy the previous state array
      newList[item].expand = !newList[item].expand; // Toggle the 'expand' property
      return newList; // Set the updated list as the new state
    });
  };
  console.log("vendorList", vendorList);
  const invoiceCount = () => {
    return vendorList?.reduce((count, item) => {
      return count + (item?.invoices?.length || 0);
    }, 0);
  };

  const calculateNetAmountForBatch = (vendorList) => {
    const totalNetAmount = vendorList?.reduce((accumulator, currentValue) => {
      const numericAmount = Number(currentValue?.NT_AMNT);
      return accumulator + numericAmount;
    }, 0);
    const formatWithCommas = totalNetAmount?.toFixed(2);
    return Number(formatWithCommas)?.toLocaleString(); // Format the total to two decimal places here
  };
  const calculateNetAmount = (vendorList) => {
    const totalNetAmount = vendorList?.reduce((accumulator, currentValue) => {
      const numericAmount = Number(currentValue?.NT_AMNT);
      return accumulator + numericAmount;
    }, 0);
    const formatWithCommas = totalNetAmount?.toFixed(2);
    return Number(formatWithCommas)?.toLocaleString()
  };


  return (
    <Grid container style={{ margin: "20px 0px", overflowY: "auto" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} mt={0} style={{ width: "0" }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{ fontWeight: "bold", color: "#000" }}
        >
          {sentToTreasury !== "sent to Treasury" && (
            <>
              <TableCell style={{ border: "none" }}>
                Invoice Count:
                {sentToTreasury === "sent to Treasury"
                  ? invoiceCount()
                  : (vendorList.length > 0 && vendorList.length) || 0}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                Net Amount:{" "}
            
                      {calculateNetAmount(vendorList)}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                Selected Invoice count:{treasuryState.invoices.length}
              </TableCell>
              {sentToTreasury !== "sent to Treasury" && (
                <TableCell style={{ border: "none" }}>
                  Selected Invoices Net Amount Total:
                  {Number(Number(sumNetAmount).toFixed(2)).toLocaleString()}
                </TableCell>
              )}
            </>
          )}
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ fontWeight: "bold" }}>
          {validate && treasuryState.invoices.length == 0 ? (
            <span style={{ color: "red", marginBottom: "5px" }}>
              {" "}
              "Please Select Invoices!"
            </span>
          ) : sumNetAmount <= 0 && validate ? (
            <span style={{ color: "red", marginBottom: "5px" }}>
              {" "}
              "Amount is not Payable"
            </span>
          ) : (
            ""
          )}
        </Grid>
        <TableContainer
          className="scrollable"
          style={{
            maxHeight: "400px",
            minHeight: "100px",
            overflowY: "auto",
          }}
        >
          {sentToTreasury === "sent to Treasury" ? (
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
              sx={{
                height: 40,
              }}
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4", height: 60 }}>
                  <TableCell></TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Batch Reference
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30"}}>
                    Batch Date
                  </TableCell>
                
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Vendor Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Net Amount
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    comments
                  </TableCell>
                 
                 
                </TableRow>
              </TableHead>
              <TableBody>
                {vendorList.length > 0 &&
                  vendorList
                    ?.slice(
                      page * RowsPerPage,
                      page * RowsPerPage + RowsPerPage
                    )
                    ?.map((item, id) => (
                      <>
                        {(sentToTreasury === "sent to Treasury" && item?.batchNo) && (
                          <>
                            <TableRow sx={{ height: 40 }}>
                              <TableCell
                                sx={{
                                  color: "black", width: "2%"
                                }}
                              >
                                <Checkbox
                                  disabled={item.invoices?.length == 0}
                                  checked={
                                    item.invoices?.length > 0
                                      ? isChecked(item)
                                      : false
                                  }
                                  onChange={(e) => checkAll(e, item.invoices)}
                                />
                              </TableCell>
                              <TableCell
                                style={{ color: "black", width: "15%",  cursor: "pointer", }}
                                onClick={() => show(id)}
                              >
                                {item?.batchRef}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: "black",
                                  width: "15%",
                                
                                }}
                              
                              >
                                {item?.batchDate &&
                                  moment(item?.batchDate).format("DD-MMM-YYYY")}
                              </TableCell>
                           
                              <TableCell
                                style={{ color: "black", width: "15%" }}
                              >
                                {item?.vendor_Name}
                              </TableCell>
                              <TableCell
                                style={{ color: "black", width: "15%",textAlign:"right"}}
                              >
                                {calculateNetAmountForBatch(item.invoices)}
                              </TableCell>
                              <TableCell
                                style={{ color: "black", width: "15%" }}
                              >
                                {item?.comments}
                              </TableCell>
                            
                            </TableRow>

                            {/* inner table that expend */}
                            {item?.expand && (
                              <TableRow>
                                <TableCell colSpan={6}>
                                  <Table
                                    style={{ margin: "20px 0px" }}
                                    aria-label="a dense table"
                                    size="small"
                                  >
                                    <TableHead>
                                      <TableRow
                                        sx={{ backgroundColor: "#EFF2F4" }}
                                      >
                                        {/* <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          <Checkbox
                                            disabled={item.invoices.length == 0}
                                            checked={
                                              item.invoices.length > 0
                                                ? isChecked(item)
                                                : false
                                            }
                                            onChange={(e) =>
                                              checkAll(e, item.invoices)
                                            }
                                          />
                                        </TableCell> */}
                                      
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          Invoice Date
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          Posting Date
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          Clearing Documents
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          Clearing Date
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          Invoice No
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          Invoice Description
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          Invoice Amount
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          ITW Amount
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          STW Amount
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#031C30",
                                          }}
                                        >
                                          Net Amount
                                        </TableCell>
                                        {/* {sentToTreasury ===
                                          "sent to Treasury" && (
                                          <>
                                            <TableCell
                                              sx={{
                                                // textAlign: "center",
                                                fontWeight: "bold",
                                                color: "#031C30",
                                              }}
                                            >
                                              Batch Ref
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                // textAlign: "center",
                                                fontWeight: "bold",
                                                color: "#031C30",
                                              }}
                                            >
                                              Batch Date
                                            </TableCell>
                                          </>
                                        )} */}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {item.invoices.map((invoiceItem, id) => (
                                        <TableRow key={id} sx={{height: 40}}>
                                          {/* <TableCell
                                            style={{ textAlign: "center" }}
                                          >
                                            {invoiceItem?.Invoice_Id && (
                                              <Checkbox
                                                checked={treasuryState.invoices.some(
                                                  (arrVal) =>
                                                    arrVal ===
                                                    invoiceItem?.Invoice_Id
                                                )}
                                                onChange={(e) => {
                                                  incoiceChecked(
                                                    e,
                                                    invoiceItem?.Invoice_Id
                                                  );
                                                }}
                                              />
                                            )}
                                          </TableCell> */}
                                         
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "10%",
                                            }}
                                          >
                                            {invoiceItem?.Invoice_Date &&
                                              moment(
                                                invoiceItem?.Invoice_Date
                                              ).format("DD-MMM-YYYY")}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "10%",
                                            }}
                                          >
                                            {invoiceItem?.Posting_Date &&
                                              moment(
                                                invoiceItem?.Posting_Date
                                              ).format("DD-MMM-YYYY")}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "8%",
                                            }}
                                          >
                                            {invoiceItem?.Document_No}
                                          </TableCell>{" "}
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "8%",
                                            }}
                                          >
                                            {invoiceItem?.Clearing_Date &&
                                              moment(
                                                invoiceItem?.Clearing_Date
                                              ).format("DD-MMM-YYYY")}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "10%",
                                            }}
                                          >
                                            {invoiceItem?.Invoice_No}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "12%",
                                            }}
                                          >
                                            {invoiceItem?.Invoice_Desc}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "14%",
                                              textAlign:"right",
                                            }}
                                          >
                                            {Number(
                                            Number(invoiceItem?.INV_AMT)?.toFixed(2)
                                            ).toLocaleString()}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "10%",
                                              textAlign:"right"
                                            }}
                                          >
                                            {Number(
                                           Number(invoiceItem?.INC_TAX)?.toFixed(2)
                                            ).toLocaleString()}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "10%",
                                              textAlign:"right"
                                            }}
                                          >
                                            {Number(
                                              Number(invoiceItem?.WH_TAX)?.toFixed(2)
                                            ).toLocaleString()}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "black",
                                              width: "14%",
                                              textAlign:"right"
                                            }}
                                          >
                                            {Number(
                                              Number(invoiceItem?.NT_AMNT).toFixed(2)
                                            ).toLocaleString()}
                                          </TableCell>
                                          {/* {sentToTreasury ===
                                            "sent to Treasury" && (
                                            <>
                                              <TableCell
                                                style={{
                                                  color: "black",
                                                  width: "15%",
                                                }}
                                              >
                                                {invoiceItem?.Batch_Id}
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  color: "black",
                                                  width: "15%",
                                                }}
                                              >
                                                {invoiceItem?.BatchDate &&
                                                  moment(
                                                    invoiceItem?.BatchDate
                                                  ).format("YYYY-MM-DD")}
                                              </TableCell>
                                            </>
                                          )} */}
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableCell>
                              </TableRow>
                            )}
                          </>
                        )}
                      </>
                    ))}
              </TableBody>
              {loading && <TableSkeleton noOfColumns={6} noOfLines={3} />}
            </Table>
          ) : (
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
              sx={{
                height: 40,
              }}
            >
              <TableHead style={{ position: "sticky", top: 0, zIndex: "1" }}>
                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    <Checkbox
                      disabled={vendorList.length == 0}
                      checked={
                        vendorList.length > 0
                          ? treasuryState.invoices.length == vendorList.length
                          : false
                      }
                      onChange={(e) => checkAll(e, vendorList)}
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Vendor Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Invoice Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Posting Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Clearing Documents
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Clearing Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Invoice No
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Invoice Description
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Invoice Amount
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    ITW Amount
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    STW Amount
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Net Amount
                  </TableCell>
                  {sentToTreasury === "sent to Treasury" && (
                    <>
                      <TableCell
                        sx={{
                          // textAlign: "center",
                          fontWeight: "bold",
                          color: "#031C30",
                        }}
                      >
                        Batch Ref
                      </TableCell>
                      <TableCell
                        sx={{
                          // textAlign: "center",
                          fontWeight: "bold",
                          color: "#031C30",
                        }}
                      >
                        Batch Date
                      </TableCell>
                    </>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {vendorList.length > 0 &&
                  vendorList
                    ?.slice(
                      page * RowsPerPage,
                      page * RowsPerPage + RowsPerPage
                    )
                    ?.map((item, id) => (
                      <>
                        {((!item?.Batch_Id &&
                          sentToTreasury !== "sent to Treasury") ||
                          (sentToTreasury === "sent to Treasury" &&
                            !item?.BatchDocument)) && (
                          <TableRow key={id}>
                            <TableCell style={{ textAlign: "center" }}>
                              {item?.Invoice_Id && (
                                <Checkbox
                                  checked={treasuryState.invoices.some(
                                    (arrVal) => arrVal === item?.Invoice_Id
                                  )}
                                  onChange={(e) => {
                                    incoiceChecked(e, item?.Invoice_Id);
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "15%" }}>
                              {item?.Vendor_Name}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "10%" }}>
                              {item?.Invoice_Date &&
                                moment(item?.Invoice_Date).format(
                                  "DD-MMM-YYYY"
                                )}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "10%" }}>
                              {item?.Posting_Date &&
                                moment(item?.Posting_Date).format(
                                  "DD-MMM-YYYY"
                                )}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "12%" }}>
                              {item?.Document_No}
                            </TableCell>{" "}
                            <TableCell style={{ color: "black", width: "10%" }}>
                              {item?.Clearing_Date &&
                                moment(item?.Clearing_Date).format(
                                  "DD-MMM-YYYY"
                                )}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "10%" }}>
                              {item?.Invoice_No}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "15%" }}>
                              {item?.Invoice_Desc}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "15%" ,textAlign:"right"}}>
                              {Number(Number(item?.INV_AMT)?.toFixed(2))?.toLocaleString()}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "10%",textAlign:"right" }}>
                              {Number(Number(item?.INC_TAX)?.toFixed(2))?.toLocaleString()}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "10%", textAlign:"right" }}>
                              {Number(Number(item?.WH_TAX)?.toFixed(2)).toLocaleString()}
                            </TableCell>
                            <TableCell style={{ color: "black", width: "15%" ,textAlign:"right"}}>
                              {Number(Number(item?.NT_AMNT)?.toFixed(2)).toLocaleString()}
                            </TableCell>
                            {sentToTreasury === "sent to Treasury" && (
                              <>
                                <TableCell
                                  style={{ color: "black", width: "15%" }}
                                >
                                  {item?.Batch_Id}
                                </TableCell>
                                <TableCell
                                  style={{ color: "black", width: "15%" }}
                                >
                                  {item?.BatchDate &&
                                    moment(item?.BatchDate).format(
                                      "YYYY-MM-DD"
                                    )}
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                        )}
                      </>
                    ))}
              </TableBody>
              {loading && <TableSkeleton noOfColumns={12} noOfLines={3} />}
            </Table>
          )}
          {vendorList?.length === 0 && !loading ? (
            <>
              <EmptyData />
            </>
          ) : (
            ""
          )}
        </TableContainer>
      </Grid>
    </Grid>
  );
}

export default VendorFinancingTable;
